const Translation = {
  access_point: "Puerta de acceso",
  accessPoints: "Puertas de acceso",
  vehicle_type: "Tipo de vehículo",
  vehicleTypes: "Tipos de vehículo",
  booking_date: "Fecha programada",
  booking_ref: "ID de reserva",
  error_something_went_wrong: "Algo salió mal...",
  filters: "Filtros",
  filter: "Filtro",
  Status: "Estado",
  statuses: "Estados",
  Projects: "Proyectos",
  Organization: "Organización",
  organizations: "Organizaciones",
  Organizations: "Organizaciones",
  Tracking: "Seguimiento",
  vehicle_tracking: "Seguimiento de vehículos",
  vehicle_tracking_description:
    "Habilitar acceso al seguimiento de vehículos y enrutamiento móvil",
  reset_filter: "Restablecer filtro",
  apply_filter: "Aplicar filtro",
  users: "Usuarios",
  total_user: "Total de usuarios",
  total_Organization: "Total de organizaciones",
  active_users: "Usuarios activos",
  clear_all: "Limpiar todo",
  showing: "Mostrando",
  no_sdata_found: "No se encontraron datos",
  entries_of: "de entradas",
  entries: "Entradas",
  search_by_User_parameter_in_userlist:
    "Buscar por nombre de usuario, organización o correo electrónico",
  search_by_project_name: "Buscar por nombre del proyecto",
  organization_Name: "Nombre de la organización",
  organization_Admin: "Administrador de la organización",
  Country: "País",
  associated_Projects: "Proyectos asociados",
  others: "Otros",
  search_by_organization_name: "Buscar por nombre de la organización",
  close: "Cerrar",
  tap_to_edit: "Toca para editar la imagen de perfil",
  first_name_required: "El nombre es obligatorio",
  last_name_required: "El apellido es obligatorio",
  email_name_required: "El correo es obligatorio",
  phone_name_required: "El teléfono es obligatorio",
  email: "Correo electrónico",
  phone: "Teléfono",
  save_details: "Guardar detalles",
  organization_role: "Rol de la organización",
  user_status: "Estado del usuario",
  global_user_status: "Estado global del usuario",
  personal_details: "Detalles personales",
  organization_created: "Organización creada correctamente",
  select_country: "Seleccionar país",
  org_name_required: "El nombre de la organización es obligatorio",
  address_required: "La dirección es obligatoria",
  city_required: "La ciudad es obligatoria",
  saved_successfully: "Guardado correctamente",
  organization_details: "Detalles de la organización",
  address_line_1_required: "Dirección 1 es obligatoria",
  address_line_2_required: "Dirección 2 es obligatoria",
  zip_required: "El código postal es obligatorio",
  country_required: "El país es obligatorio",
  organization_logo: "Logo de la organización",
  statement_info_text:
    "Para incluir enlaces en el texto, usa el formato {texto, https://link.com}.",
  question_required: "La pregunta es obligatoria",
  create_project: "Crear proyecto",
  user_data_saved_successfully: "Datos del usuario actualizados correctamente",
  section_visibility: "Visibilidad de secciones",
  project_setting: "Configuración del proyecto",
  project_settings_description:
    "La configuración del proyecto permite acceder a funciones Pro e integraciones.",
  integration: "Integración",
  integration_description:
    "Permite habilitar y configurar integraciones de terceros.",
  enable_pro_settings: "Habilitar configuración Pro",
  procore_daily_log: "Registro diario Procore",
  procore_daily_log_description:
    "Habilitar acceso para configurar Procore Daily Log.",
  enable_integrations: "Habilitar integraciones",
  fors_validation: "Validación FORS",
  fors_validation_description: "Permitir acceso a la validación FORS.",
  procore: "Procore",
  procore_description: "Permitir acceso a la integración de Procore.",
  feature_updated: "Función actualizada correctamente",
  integrations_updated: "Integraciones actualizadas correctamente",
  verification: "Verificación",
  organization_state: "Estado de la organización",
  select_org_state: "Seleccionar estado de la organización",
  verified_email_domain: "Dominio de correo verificado",
  email_domain_required: "Selecciona un dominio de correo verificado",
  verified: "Verificado",
  unverified: "No verificado",
  scheduling: "Programación",
  field: "Campo",
  edit: "Editar",
  duration: "Duración",
  core_fields: "Campos principales",
  active: "Activo",
  Active: "Activo",
  Inactive: "Inactivo",
  mandatory: "Obligatorio",
  flexible_fields: "Campos flexibles",
  add_new_field: "Agregar nuevo campo",
  core_field_saved_success_fully: "Campo principal guardado correctamente",
  error_login_again: "Credenciales no proporcionadas",
  vehicle_types: "Tipos de vehículo",
  included: "Incluido",
  cancel: "Cancelar",
  save: "Guardar",
  change_associated_organization: "Cambiar organización asociada",
  confirm: "Confirmar",
  new_organization: "Nueva organización",
  changed_organization: "Organización cambiada correctamente",
  no_data_found: "No se encontraron datos",
  collapse: "Colapsar",
  new_project: "Nuevo proyecto",
  field_removed: "Campo eliminado",
  this_field_is_active: "Este campo está activo",
  this_field_is_mandatory: "Este campo es obligatorio",
  core_field_saved: "Campo principal guardado correctamente",
  search: "Buscar",
  from: "Desde",
  to: "Hasta",
  today: "Hoy",
  yesterday: "Ayer",
  start_date_greater_than_end_date:
    "La fecha inicial no puede ser mayor que la final",
  back: "Atrás",
  account_created: "Cuenta creada",
  last_login: "Último acceso",
  link: "Enlace",
  status: "Estado",
  First_Name: "Nombre",
  Last_Name: "Apellido",
  Email_Address: "Correo electrónico",
  Associated_Organization: "Organización asociada",
  Associated_Projects: "Proyectos asociados",
  account_manager: "Gestor de cuenta",
  organization: "Organización",
  apply_filters: "Aplicar filtros",
  next: "Siguiente",
  previous: "Anterior",
  no_activity_found: "No se encontró actividad",
  create_organization: "Crear organización",
  forgot_password: "¿Olvidaste tu contraseña?",
  welcometext_forgot:
    "Introduce tu correo y te enviaremos instrucciones para restablecerla.",
  backtologin: "Volver al inicio de sesión",
  submit: "Enviar",
  error_email_required: "El correo es obligatorio",
  error_valid_email: "Introduce un correo válido",
  welcometext: "Bienvenido a Voyage Control",
  pls_login: "Por favor inicia sesión",
  password: "Contraseña",
  login: "Iniciar sesión",
  booking_type: "Tipo de reserva",
  site_defaults: "Configuración predeterminada del sitio",
  project: "Proyecto",
  total_project: "Total de proyectos",
  project_status: "Estado del proyecto",
  active_project: "Proyectos activos",
  site_settings: "Configuración del sitio",
  automatic_approval: "Aprobación automática",
  automatic_approval_description:
    "Las reservas se aprobarán automáticamente tras su creación.",
  unauthorize_user: "Acceso denegado",
  edit_project_details: "Editar detalles del proyecto",
  credential_not_provided: "Credenciales no proporcionadas",
  region_not_available: "Región no disponible",
  btn_back: "Atrás",
  date_created: "Fecha de creación",
  local_site_time: "Hora local del sitio",
  successfully_edit_contact: "Contacto editado correctamente",
  invalid_url: "URL inválida",
  project_owner_email_address: "Correo del propietario del proyecto",
  project_edited: "Proyecto actualizado",
  please_contact_selected_owner_to_accept_the_invitation:
    "Contacta al propietario para aceptar la invitación",
  please_select_owner: "Selecciona un propietario",
  success_fully_added_contact: "Contacto agregado correctamente",
  image_uploaded: "Imagen subida correctamente",
  contact_deleted: "Contacto eliminado",
  project_organization: "Organización del proyecto",
  select_site: "Seleccionar sitio",
  any_integration_lost: "Se perderán las configuraciones de integración",
  disable: "Deshabilitar",
  go: "Ir",
  actions: "Acciones",
  go_to_project: "Ir al proyecto",
  project_settings_updated: "Configuración del proyecto actualizada",
  invalid_date: "Fecha inválida",
  added_flexible_field_data: "Campo flexible agregado",
  title_is_required: "El título es obligatorio",
  question_is_required: "La pregunta es obligatoria",
  option_is_required: "La opción es obligatoria",
  title: "Título*",
  question: "Pregunta*",
  statement: "Declaración*",
  field_type: "Tipo de campo*",
  options: "Opciones",
  add: "Agregar",
  add_new_option: "Agregar nueva opción",
  edit_field: "Editar campo",
  add_field: "Agregar campo",
  free_text: "Texto libre",
  confirm_text: "Confirma eliminar permanentemente",
  can_not_undo: "No se puede deshacer",
  delete: "Eliminar",
  select_role: "Seleccionar rol",
  user_removed: "Usuario eliminado",
  organization_updated: "Rol actualizado",
  no_user: "Usuario no encontrado",
  flex_fields_added: "Campos flexibles agregados",
  edit_flex_field: "Editar campo flexible",
  add_flex_field: "Agregar campo flexible",
  org_name: "Nombre de la organización",
  address_line_1: "Dirección 1",
  address_line_2: "Dirección 2",
  town_city: "Ciudad",
  town_city_required: "La ciudad es obligatoria",
  zip_code: "Código postal",
  zip_code_required: "Código postal obligatorio",
  country: "País",
  reset_password: "Restablecer contraseña",
  welcometext_reset: "La contraseña debe tener al menos 6 caracteres",
  confirmpassword: "Confirmar contraseña",
  error_password_required: "Contraseña obligatoria",
  error_confirm_password_required: "Confirmar contraseña obligatoria",
  error_password_upper: "Al menos una mayúscula",
  error_password_lower: "Al menos una minúscula",
  error_password_number: "Al menos un número",
  error_password_special: "Al menos un carácter especial",
  error_password_min: "Mínimo 6 caracteres",
  error_password_max: "Máximo 16 caracteres",
  error_valid_password:
    "Debe contener mayúscula, minúscula, número y carácter especial (6-16).",
  error_password_not_match: "Las contraseñas no coinciden",
  success_message: "Contraseña restablecida correctamente",
  error_language_required: "Idioma obligatorio",
  error_dateformat_required: "Formato de fecha obligatorio",
  error_timeformat_invalid: "Formato de hora inválido",
  error_startday_required: "Día inicial obligatorio",
  error_status_required: "Estado obligatorio",
  details_heading_text: "Detalles del proyecto",
  project_name: "Nombre del proyecto",
  project_lead: "Responsable del proyecto",
  project_owner: "Propietario del proyecto",
  project_org: "Organización del proyecto",
  project_add: "Dirección",
  edit_project_detail: "Editar detalles del proyecto",
  heading_contact: "Detalles de contacto",
  logo: "Logo",
  home_page_banner: "Banner de inicio",
  details_image_text: "Imágenes y pantalla de inicio",
  label_sitename: "Nombre del proyecto",
  label_siteadd: "Dirección del proyecto",
  label_siteOwner: "Propietario del proyecto",
  label_siteOrg: "Organización del proyecto",
  label_accManager: "Gestor de cuenta",
  label_hubspot: "Enlace de HubSpot",
  label_home_banner: "Banner de inicio",
  label_region: "Región",
  error_region_required: "La región es obligatoria",
  label_home_screen_message: "Mensaje de la pantalla de inicio",
  error_image_invalid: "Sube un archivo de imagen válido",
  error_siteLogo_required: "El logo es obligatorio",
  error_homebanner_required: "El banner es obligatorio",
  error_sitename_required: "El nombre del proyecto es obligatorio",
  error_siteadd_required: "La dirección del proyecto es obligatoria",
  error_siteowner_required: "El propietario del proyecto es obligatorio",
  error_siteorg_required: "La organización del proyecto es obligatoria",
  error_acc_manager_required: "El gestor de cuenta es obligatorio",
  error_hubspot_url: "La URL de HubSpot es obligatoria",
  error_homemessage_required: "El mensaje de inicio es obligatorio",
  contact_heading_text: "Contacto",
  add_contact: "Agregar nuevo contacto",
  edit_contact: "Editar contacto",
  label_name: "Nombre",
  label_position: "Cargo",
  label_phone: "Teléfono (opcional)",
  btn_add: "Agregar",
  btn_remove: "Eliminar",
  btn_edit: "Editar",
  btn_save: "Guardar",
  error_name_required: "El nombre es obligatorio",
  error_position_required: "El cargo es obligatorio",
  error_valid_phonenumber: "Introduce un número válido",
  error_required_phone: "El teléfono es obligatorio",
  drag_and_drop: "Arrastra y suelta archivos",
  browse_file: "Explorar archivos",
  image_uploading: "Subiendo imagen",
  select: "Seleccionar",
  address: "Dirección",
  hubspot: "HubSpot",
  "pre-live": "En vivo",
  paused: "Pausado",
  finished: "Finalizado",
  invited: "Invitado",
  Invited: "Invitado",
  restricted: "Restringido",
  blocked: "Bloqueado",
  Approved: "Aprobado",
  Blocked: "Bloqueado",
  Pending: "Pendiente",
  logout: "Cerrar sesión",
  email_optional_label: "Correo electrónico (opcional)",
  project_information: "Información del proyecto",
  project_settings: "Configuración del proyecto",
  booking_fields: "Campos de reserva",
  project_users: "Usuarios del proyecto",
  project_activity: "Actividad del proyecto",
  emission_tracking: "Seguimiento de emisiones",
  equipment_emissions: "Emisiones de equipos",
  emissionFactor: "Factor de emisión",
  vehicle_emissions: "Emisiones de vehículos",
  equipment_master_add: "Agregar equipo",
  vehicle: "Vehículo",
  milesgallons_or_kmLitres: "Millas/galón o km/litro",
  emission_factor: "Factor de emisión",
  equipment: "Equipo",
  emissions: "Emisiones",
  category: "Categoría",
  brand: "Marca",
  model: "Modelo",
  emission_settings: "Configuración de emisiones",
  transport_round_trip_settings: "Configuración de viaje de ida y vuelta",
  organization_info: "Información de la organización",
  organization_users: "Usuarios de la organización",
  organization_activity: "Actividad de la organización",
  user_information: "Información del usuario",
  associated_organizations: "Organizaciones asociadas",
  associated_projects: "Proyectos asociados",
  user_activity: "Actividad del usuario",
  vehicles_manager: "Gestor de vehículos",
  vehicle_type_added: "Tipo de vehículo agregado",
  vehicle_type_updated: "Tipo de vehículo actualizado",
  vehicle_type_deleted: "Tipo de vehículo eliminado",
  no_vehicles_found: "No se encontraron vehículos",
  add_vehicle: "Agregar nuevo tipo de vehículo",
  multi_vehicle_description:
    "Permite definir múltiples vehículos en una sola reserva.",
  recurring_description:
    "Permite programar reservas recurrentes semanal o mensualmente.",
  resource_only_description:
    "Reservar solo recursos sin ocupar espacio en el acceso.",
  multi_resource_description:
    "Puede habilitar o deshabilitar la posibilidad de asignar y gestionar múltiples recursos para una reserva a nivel de sitio. Cuando está habilitada, los usuarios pueden seleccionar y asignar más de un recurso a una misma reserva. Cuando está deshabilitada, las reservas se limitan a la asignación de un único recurso.",  
  multi_vehicle: "Múltiples vehículos",
  recurring: "Recurrente",
  resource_only: "Solo recurso",
  multi_resource: "Múltiples recursos",
  resource: "Recurso",
  invite_user: "Invitar usuario",
  add_another: "Agregar otro",
  role: "Rol",
  project_admin: "Administrador del proyecto",
  project_manager: "Gestor del proyecto",
  project_user: "Usuario del proyecto",
  send_invite: "Enviar invitación",
  invite_sent: "Invitación enviada correctamente",
  security_guard: "Guardia de seguridad",
  view_only: "Solo lectura",
  project_senior_user: "Usuario senior del proyecto",
  profile: "Perfil",
  language: "Idioma",
  booking_contact: "Contacto de reserva",
  comments: "Comentarios",
  phone_number: "Número de teléfono",
  project_role: "Rol del proyecto",
  project_role_updated: "Rol actualizado",
  Van: "Furgoneta",
  "18 Wheeler": "Camión articulado",
  "Box Truck": "Camión caja",
  "Car + Trailer": "Coche + remolque",
  Car: "Coche",
  "Concrete Truck": "Camión de hormigón",
  "Dump Truck": "Camión volquete",
  "Flatbed Truck": "Camión plataforma",
  "Garbage Truck": "Camión de basura",
  "Mobile Crane": "Grúa móvil",
  Other: "Otro",
  "Pickup Truck": "Camioneta",
  "Pump Truck": "Camión bomba",
  Tanker: "Camión cisterna",
  "Articulated Vehicle": "Vehículo articulado",
  "Raised Floor Trailer": "Remolque de piso alto",
  "Low Floor Trailer": "Remolque de piso bajo",
  "15t Flat Truck": "Camión plano 15t",
  "15t Unic Truck": "Camión grúa 15t",
  "10t Flat Truck": "Camión plano 10t",
  "10t Unic Truck": "Camión grúa 10t",
  "8t Flat Truck": "Camión plano 8t",
  "8t Unic Truck": "Camión grúa 8t",
  "4t Flat Truck": "Camión plano 4t",
  "4t Unic Truck": "Camión grúa 4t",
  "2t Flat Truck": "Camión plano 2t",
  "Concrete Mixer Truck": "Camión mezclador",
  "16t Rough Terrain-Crane": "Grúa todoterreno 16t",
  "25t Rough Terrain-Crane": "Grúa todoterreno 25t",
  "50t Rough Terrain-Crane": "Grúa todoterreno 50t",
  "65t Rough Terrain-Crane": "Grúa todoterreno 65t",
  "10t dump truck": "Camión volquete 10t",
  "10t Dump Truck": "Camión volquete 10t",
  "10t arm roll": "Camión brazo rodante 10t",
  "10t Arm Roll": "Camión brazo rodante 10t",
  "4t arm roll": "Camión brazo rodante 4t",
  "4t Arm Roll": "Camión brazo rodante 4t",
  "WIRE FEEDER": "Alimentador de alambre",
  Excavator: "Excavadora",
  TRUCK: "Camión",
  WELDER: "Soldador",
  TELEHANDLERS: "Manipuladores telescópicos",
  FORKLIFTS: "Montacargas",
  "SCISSOR LIFTS": "Plataformas de tijera",
  "ARTICULATING BOOMS": "Plataformas articuladas",
  Loader: "Cargador",
  "Truck Crane": "Grúa sobre camión",
  "Rough Terrain Crane": "Grúa todoterreno",
  "Crawler Crane": "Grúa de oruga",
  "Boom Lift": "Elevador de brazo",
  "Straight Forklift": "Montacargas recto",
  "Reach Forklift": "Montacargas retráctil",
  Crane: "Grúa",
  Hoist: "Polipasto",
  "Pressure Washer": "Lavadora a presión",
  "Scissor Lift": "Elevador de tijera",
  "Track Loader": "Cargador de oruga",
  ForkLift: "Montacargas",

  "Project Admin": "Administrador del proyecto",
  "Project Manager": "Gestor del proyecto",
  "Project Owner": "Propietario del proyecto",
  "Project User": "Usuario del proyecto",
  "Environment Admin": "Administrador ambiental",
  "Equipment Analytics Admin": "Administrador de análisis de equipos",
  "Project Senior User": "Usuario senior del proyecto",
  "Supplier Equipment Coordinator": "Coordinador de equipos proveedor",
  "View Only": "Solo lectura",

  role_management: "Gestión de roles",
  role_management_description:
    "Permite definir y gestionar roles y permisos de usuarios.",
  name: "Nombre",
  role_name: "Nombre del rol",
  role_name_required: "Nombre del rol obligatorio",
  role_code: "Código del rol",
  users_count: "Cantidad de usuarios",
  create_role: "Crear rol",
  update_role: "Actualizar rol",
  permissions: "Permisos",
  role_created: "Rol creado correctamente",
  role_permissions_updated: "Permisos actualizados",
  roles: "Roles",
  total_roles: "Total de roles",
  select_all: "Seleccionar todo",

  trade_type: "Tipo de comercio",
  select_trade_type: "Selecciona tipo de comercio",

  flexible_forms: "Formularios flexibles",
  add_preset_form: "Agregar formulario predefinido",
  create_preset_form: "Crear formulario",
  update_preset_form: "Actualizar formulario",
  order: "Orden",
  form: "Formulario",
  forms: "Formularios",
  preset_form: "Formulario predefinido",
  add_question: "Agregar pregunta",
  add_section: "Agregar sección",
  form_title: "Título del formulario",
  form_title_is_required: "Título obligatorio",
  location_type: "Ubicación",
  section_title: "Título de sección",
  section_title_is_required: "Título de sección obligatorio",
  new_question: "Nueva pregunta",
  no_flex_form: "No hay formularios configurados",
  check_in_form: "Formulario de check-in",
  check_out_form: "Formulario de check-out",
  booking: "Reserva",
  checkin: "Check-in",
  checkout: "Check-out",
  form_updated_successfully: "Formulario actualizado",
  form_created_successfully: "Formulario creado",
  label: "Etiqueta",
  question_title: "Pregunta",
  form_deleted_successfully: "Formulario eliminado",
  create_new_form: "Crear formulario",
  please_fill_the_required_fields: "Faltan campos obligatorios",
  save_to_preset_form: "Guardar como predefinido",
  save_form: "Guardar formulario",
  question_is_mandatory: "Pregunta obligatoria",
  go_to_section_base_on_answer: "Ir a sección según respuesta",
  continue_to: "Continuar a",
  delete_preset_form: "Eliminar formulario",
  edit_preset_form: "Editar formulario",
  platform: "Plataforma",
  platforms: "Plataformas",
  create_platform: "Crear plataforma",
  edit_platform: "Editar plataforma",
  total_platforms: "Total de plataformas",
  description: "Descripción",
  url: "Correo electrónico",
  custom_duration: "Duración personalizada",
  webhooks: "Webhooks",
  events: "Eventos",
  listening_for: "Escuchando",
  request_filters: "Filtros de solicitud",
  total_Webhooks: "Total de webhooks",
  create_webhook: "Crear webhook",
  by_webhook_events: "Por eventos de webhook",
  by_webhook_statuses: "Por estados de webhook",
  statuses_selected: "Estados seleccionados",
  events_selected: "Eventos seleccionados",
  requested_at: "Solicitado en",
  event: "Evento",
  global_masters: "Maestros globales",
  equipment_master: "Maestro de equipos",
  vehicle_master: "Maestro de vehículos",

  my_account: "Mi cuenta",
  account_info: "Información de la cuenta",
  info: "Información",
  preferences: "Preferencias",
  my_preferences: "Mis preferencias",
  user_created_at: "Usuario creado el",
  user_last_update_at: "Última actualización del usuario",
  projects: "Proyectos",
  date_format: "Formato de fecha",
  time_format: "Formato de hora",
  calendar_start_day: "Día de inicio de la semana",
  select_platform: "Seleccionar plataforma",

  // Trade Type translation
  None: "------------------------------------",
  "Existing Building Demolition": "Demolición de edificio existente",
  "CIP concrete, precast concrete, rebar":
    "Hormigón CIP, hormigón prefabricado, refuerzo",
  CMU: "CMU",
  "Structural Steel Framing, Steel Decking, Cold Formed Metal Framing":
    "Estructura de acero, losas de acero, estructura metálica conformada en frío",
  "Rough carpentry": "Carpintería básica",
  "Thermal insulation for GWB assemblies and roofing, roofing and siding panels, membrane roofing":
    "Aislamiento térmico para GWB y techos, paneles de revestimiento, techos de membrana",
  "Doors, Frames, Hardware, Interior and Exterior Glazing, Specialty Doors":
    "Puertas, marcos, herrajes, acristalamiento interior/exterior, puertas especiales",
  "GWB assemblies, paint & coatings, flooring, acoustical ceilings":
    "GWB, pintura y recubrimientos, suelos, techos acústicos",
  "Site concrete and asphalt paving":
    "Hormigón de obra y pavimentación asfáltica",
  "Earthwork & utilities": "Movimiento de tierras y servicios",
  "Temporary Construction": "Construcción temporal",
  "Frame construction": "Construcción de estructura",
  "Finishing construction": "Construcción de acabado",
  "Equipment construction": "Construcción de equipos",
  "Miscellaneous construction": "Construcción miscelánea",

  region_state: "Región/Estado",

  // System Banners
  system_banners: "Banners del sistema",
  create_banner: "Crear banner",
  edit_banner: "Editar banner",
  banner_title: "Título",
  banner_message: "Mensaje",
  banner_html_content: "Contenido HTML (opcional)",
  banner_type: "Tipo",
  banner_priority: "Prioridad",
  banner_display_mode: "Modo de visualización",
  banner_target_type: "Tipo de objetivo",
  banner_start_date: "Fecha de inicio",
  banner_end_date: "Fecha de fin (opcional)",
  banner_detail_url: "URL de detalle (opcional)",
  banner_active: "Activo",
  banner_dismissible: "Descartable",
  select_project: "Seleccionar proyecto",
  select_organization: "Seleccionar organización",
  all_users: "Todos los usuarios",
  users_with_role: "Usuarios con rol",
  global_banner: "Banner global",
  after_login_popup: "Popup después del login",
  homepage_banner: "Banner de inicio",
  notification: "Notificación",
  disaster_alert: "Alerta de desastre",
  maintenance: "Mantenimiento",
  system_issue: "Problema del sistema",
  general: "General",
  low: "Bajo",
  medium: "Medio",
  high: "Alto",
  critical: "Crítico",
  banner_created_successfully: "Banner creado correctamente",
  banner_updated_successfully: "Banner actualizado correctamente",
  banner_deleted_successfully: "Banner eliminado correctamente",
  failed_to_load_system_banners: "Error al cargar los banners",
  failed_to_delete_banner: "Error al eliminar el banner",
  failed_to_save_banner: "Error al guardar el banner",
  are_you_sure_delete_banner: "¿Seguro que deseas eliminar este banner?",
  no_banners_found: "No se encontraron banners",
  target: "Objetivo",
  update: "Actualizar",
  create: "Crear",
  start_date: "Fecha de inicio",
  end_date: "Fecha de fin",

  // System Banner Error Messages
  Err_system_banner_mark_as_read_failed: "No se pudo marcar como leído",
  Err_system_banner_mark_as_read_error: "Error al marcar como leído",
  all_items_loaded: "Todos los elementos cargados",
  total: "Total",
  loading: "Cargando",
  error_loading_more: "Error al cargar más elementos",
  retry: "Reintentar",
  project_create_under_org: "Este proyecto se creará en {{org}}.",
  project_create_owner_cross_org:
    "Solo puede crear proyectos para su propia organización ({{org}}). Este propietario pertenece a {{ownerOrg}}.",
  Err_can_only_create_for_own_organization:
    "Solo puede crear proyectos para su propia organización.",

  // Global Variables (BUGS-504)
  global_variables: "Variables globales",
  anthropic_key: "Clave de Anthropic",
  anthropic_model: "Modelo de Anthropic",
  anthropic_key_help:
    "La usan todas las funciones de IA de SCP: Co-pilot, importación de proveedores, revisión de PDF de PO y BOM, categorización de materiales y análisis de EPD. La clave guardada nunca se muestra completa.",
  current_key: "Clave actual",
  new_key: "Nueva clave",
  enter_new_anthropic_key: "Pegue la nueva clave de Anthropic",
  clear_key: "Borrar clave",
  anthropic_key_clear_confirm:
    "¿Borrar la clave de Anthropic? Las funciones de IA de SCP dejarán de funcionar hasta que se guarde una clave nueva.",
  key_not_set: "Sin definir. Las funciones de IA de SCP están desactivadas hasta que se guarde una clave.",
  copilot_model: "Modelo de Co-pilot",
  copilot_model_help: "Lo usan Co-pilot, la importación de proveedores desde PDF, la revisión de PDF de PO y BOM, y el análisis de EPD.",
  categorization_model: "Modelo de categorización",
  categorization_model_help:
    "Solo lo usa la categorización de materiales con IA. Se mantiene aparte para que pueda usar un modelo más económico.",
  last_updated_by: "Última actualización por {{user}} el {{date}}",
  global_variable_saved: "Guardado. SCP lo usará en su próxima solicitud de IA (como máximo en 10 minutos).",
  loading_models: "Cargando los modelos disponibles para la clave guardada…",
  failed_to_load_models: "Error al cargar los modelos disponibles",
  go_to_anthropic_key: "Ir a Clave de Anthropic",
  model_not_in_list: "{{model}} (no disponible para la clave guardada)",
  model_context_window: "Ventana de contexto: {{tokens}} tokens",
  model_max_output: "Salida máxima: {{tokens}} tokens",
  model_released: "Publicado: {{date}}",
  model_supports: "Admite: {{list}}",
  capability_vision: "Imágenes",
  capability_adaptive_thinking: "Razonamiento adaptativo",
  capability_structured_outputs: "Salidas estructuradas",
  capability_effort: "Control de esfuerzo",
  Err_anthropic_key_not_set: "Guarde primero la clave de Anthropic; la lista de modelos se carga con ella.",
  Err_anthropic_key_invalid: "Anthropic rechazó la clave guardada. Revise la página Clave de Anthropic.",
  Err_anthropic_unavailable: "No se pudo conectar con Anthropic. Inténtelo de nuevo en un momento.",
  Err_model_not_available: "Este modelo no está disponible para la clave guardada.",
  Err_model_required: "Elija un modelo.",
  failed_to_load_global_variables: "Error al cargar las variables globales",
  failed_to_save_global_variable: "Error al guardar el cambio",
  global_variables_no_access: "Solo los administradores globales de Voyage Control pueden ver las variables globales.",

  // Inventory Ledger Alerts (BUGS-535)
  inventory_ledger_alerts: "Alertas del libro de inventario",
  inventory_ledger_alerts_help:
    "Quién recibe un correo electrónico cuando el proceso nocturno del libro de inventario falla, falla en parte o detecta que no se ejecutaron procesos anteriores. Introduzca una dirección de correo electrónico, o varias separadas por comas. Puede ser un buzón compartido o una persona.",
  ledger_alert_recipients: "Destinatarios de las alertas",
  current_recipients: "Destinatarios actuales",
  recipients: "Destinatarios",
  enter_ledger_alert_emails: "p. ej. equipo-stock@empresa.com, jane.doe@empresa.com",
  ledger_alerts_not_set: "Sin definir. Las alertas del libro de inventario solo se escriben en el registro.",
  ledger_alerts_clear_confirm:
    "¿Borrar los destinatarios de las alertas? Las alertas del libro de inventario solo se escribirán en el registro.",
  ledger_alerts_saved:
    "Guardado. El cambio se aplica a la próxima alerta del libro de inventario (como máximo en 10 minutos).",
  clear: "Borrar",
  Err_invalid_email_list: "Estas direcciones de correo electrónico no son válidas: {{list}}.",
};
export default Translation;
